export default __webpack_public_path__ + "static/media/section-A-1_LS.b62b8e72.png";